<script>
export default {
  name: 'ProductTile',
  props: {
    product: {
      type: Object,
      required: true,
    },
    canEdit: {
      type: Boolean,
      required: false,
    },
  },
  computed: {},
  methods: {
    openModal() {
      if (this.canEdit) {
        this.$emit('open-edit')
      } else {
        this.$emit('open-details')
      }
    },
    confirmDelete() {
      this.$emit('confirm-delete-product')
    },
  },
}
</script>

<template>
  <div class="product-box cursor-pointer relative">
    <button
      v-if="canEdit"
      class="text-blue absolute top-0 right-0 text-3xl mr-4 mt-2 cursor-pointer focus:outline-none"
      @click="confirmDelete"
      >✕</button
    >
    <div @click="openModal">
      <div class="product-image">
        <img :src="product.image_url" loading="lazy" class="w-full h-full" />
      </div>
      <div class="mx-4.5 mt-7 mb-3" @click="openModal">
        <h3 class="product-title">{{ product.title }}</h3>
      </div>
      <div class="product-meta"> Price: {{ product.price }} PENCIL Points </div>
    </div>
  </div>
</template>
